export default function CouncilMembership() {
    return (
        <div>
 <h4>Members</h4>
<hr/>
                <center>
                  <h4>1st Ward</h4>
                </center>
                <p>
                  <b>Helen Hlahol</b>&nbsp;<i>Council President</i>
                  <br />
                  Term Expires: January 2030
                  <br />
                  <a href="mailto:HHlahol@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;HHlahol@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:3233642402">
                    <i className="fa-solid fa-phone"></i>&nbsp;323-364-2402
                  </a>
                  <br />
                </p>
                <p>
                  <b>Shawn Ratti</b>
                  <br />
                  Term Expires: January 2030
                  <br />
                    <a href="mailto:SRatti@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;SRatti@morrisvilleboro.org
                  </a>
                  
                  <br />
                  
                  <a href="tel:2676937635">
                    <i className="fa-solid fa-phone"></i>&nbsp;267-693-7635
                  </a>
                  
                  <br />
                </p>
                <center>
                  <h4>2nd Ward</h4>
                </center>
                <p>
                  <b>Diane Lanahan</b>
                  <br />
                  Term Expires: January 2028
                  <br />
                  <a href="mailto:DLanahan@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;DLanahan@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:2675669655">
                    <i className="fa-solid fa-phone"></i>&nbsp;267-566-9655
                  </a>
                  <br />
                </p>
                <p>
                  <b>Scott Robinson</b>&nbsp;<i>Council Vice-President</i>
                  <br />
                  Term Expires: January 2028
                  <br />
                  <a href="mailto:SRobinson@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;SRobinson@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:2158131214">
                    <i className="fa-solid fa-phone"></i>&nbsp;215-813-1214
                  </a>
                  <br />
                </p>
                <center>
                  <h4>3rd Ward</h4>
                </center>
                <p>
                  <b>Deborah Colgan</b>
                  <br />
                  Term Expires: January 2030
                  <br />
                  <a href="mailto:DColgan@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;DColgan@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:6099545360">
                    <i className="fa-solid fa-phone"></i>&nbsp;609-954-5360
                  </a>
                  <br />
                </p>
                <p>
                  <b>Peggy Walsh</b>
                  <br />
                  Term Expires: January 2028
                  <br />
                  <a href="mailto:PWalsh@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;PWalsh@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:2673046353">
                    <i className="fa-solid fa-phone"></i>&nbsp;267-304-6353
                  </a>
                  <br />
                </p>
                
                <center>
                  <h4>4th Ward</h4>
                </center>
                <p>
                  <b>Marie Kelso</b>
                  <br />
                  Term Expires: January 2028
                  <br />
                  <a href="mailto:MKelso@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;MKelso@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:2155195967">
                    <i className="fa-solid fa-phone"></i>&nbsp;215-519-5967
                  </a>
                  <br />
                </p>
                <p>
                  <b>Anna Langer</b>
                  <br />
                  Term Expires: January 2030
                  <br />
                  <a href="mailto:ALanger@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;ALanger@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:2153846326">
                    <i className="fa-solid fa-phone"></i>&nbsp;215-384-6326
                  </a>
                  <br />
                </p>

        </div>
    )
}